module.exports = __webpack_public_path__ + "static/media/SVG_menu_search_agent.9f07e194.svg";